import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Faq } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesFaq, validationSchemaFaq } from "./FaqCommon"
import { useCreateFaq } from "../../hooks/faqs"
import FaqForm from "./FaqForm"

export default function FaqCreate() {
  const createFaq = useCreateFaq()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesFaq(), [])
  const validationSchema = useMemo(() => validationSchemaFaq(), [])
  useBreadcrumbs([{ label: "FAQs", href: "/faqs/faqs" }, { label: "Creazione FAQ" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova FAQ</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createFaq.mutateAsync(values as Faq).then((faq: Faq) => {
                navigate(`/faqs/faqs/${faq.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <FaqForm />
                </Container>
                <BottomFormFixed url="/faqs/faqs"  />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
